<div id="cellarAddPopup" fxLayout="column">
  <mat-toolbar fxLayout="row" fxLayoutAlign="space-between center">
    <h1>
      {{ isEditMode ? "ویرایش روش ارسال" : "اضافه کردن روش ارسال جدید" }}
    </h1>

    <div class="d-flex align-items-center gap-3">
      <button
        *ngIf="isEditMode"
        mat-raised-button
        (click)="updateMethod()"
        color="accent"
        [disabled]="!form.valid"
      >
        <jam-icon name="check" vertical-align="middle" />
        بروز رسانی روش ارسال
      </button>

      <!-- <button
        [disabled]="(!isEditMode && pointer) || target !== 'binding'"
        (click)="deleteBinding()"
        color="warn"
        mat-button
      >
        <span>حذف آیتم</span>
        <jam-icon name="remove" vertical-align="middle"></jam-icon>
      </button> -->

      <button
        (click)="addMethod()"
        *ngIf="!isEditMode"
        mat-raised-button
        color="primary"
        [disabled]="!form.valid"
      >
        <jam-icon name="plus" vertical-align="middle" />
        اضافه کردن روش ارسال
      </button>

      <jam-icon
        name="close"
        class="close-btn mr-3"
        color="warn"
        mat-dialog-close
        vertical-align="middle"
      />
    </div>
  </mat-toolbar>
  <div class="container my-4">
    <form [formGroup]="form" class="row">
      <mat-form-field appearance="outline" class="col-12 col-lg-4">
        <mat-label>نام روش ارسال</mat-label>
        <input
          placeholder="نام روش ارسال"
          formControlName="name"
          type="text"
          matInput
        />
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-12 col-lg-4">
        <mat-label>آیکن</mat-label>
        <mat-select-trigger class="position-absolute">
          <span><jam-icon [name]="form.controls['icon'].value" /></span>
        </mat-select-trigger>
        <mat-select formControlName="icon">
          <mat-option value="archive">
            <jam-icon name="archive" />
          </mat-option>
          <mat-option value="car">
            <jam-icon name="car" />
          </mat-option>
          <mat-option value="envelope">
            <jam-icon name="envelope" />
          </mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-12 col-lg-4">
        <mat-label>هزینه ارسال</mat-label>
        <input
          placeholder="هزینه ارسال"
          formControlName="valueAdded"
          type="text"
          dir="ltr"
          matInput
        />
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-12 col-lg-4">
        <mat-label>حداقل قیمت سفارش برای ارسال رایگان</mat-label>
        <input
          placeholder="حداقل قیمت سفارش برای ارسال رایگان"
          formControlName="minPurchaseForFreeShipping"
          type="text"
          dir="ltr"
          matInput
        />
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-12 col-lg-4">
        <mat-label>شهرهای ارسال</mat-label>
        <mat-select formControlName="cities" multiple>
          <mat-option *ngFor="let city of cityList" [value]="city.id">{{city.name}}</mat-option>
        </mat-select>
      </mat-form-field>
      <mat-form-field appearance="outline" class="col-12 col-lg-4">
        <mat-label>توضیح</mat-label>
        <input
          placeholder="توضیح روش ارسال"
          formControlName="desc"
          type="text"
          matInput
        />
      </mat-form-field>
    </form>
  </div>
</div>
